<template>
  <div ref="toolsCard" class="tool-card">
    <div class="tool-card-header">
      <img :src="require(`../../../assets/img/${image}`)" />
      <div class="tool-card-header-column">
        <h1>{{ title }}</h1>
        <p>
          Starting at
          <span>{{ price }}</span>
        </p>
      </div>
    </div>
    <div class="tool-card-desc">{{ desc }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: [String, Number],
    image: [String],
    price: [Number, String],
    desc: [String],
  },
  async mounted() {
    await this.sleep(10);
    this.$refs.toolsCard.style = "transform: scale(1) !important";
  },
  methods: {
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>

<style scoped>
.tool-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 225px;
  max-width: 100%;
  height: 225px;
  width: 100%;
  background: radial-gradient(100% 100% at 44.04% 0%, #26292e 0%, #1a1c1f 100%);
  box-shadow: 2px 2px 5px #000000, inset 0px 1px 3px #000000;
  border-radius: 7px;
  padding: 10px;
  transform: scale(0.5);
  transition: 0.4s;
  justify-content: space-evenly;
}

.tool-card-header {
  display: flex;
}

.tool-card-header-column {
  display: flex;
  flex-direction: column;
  margin-left: 8px;
}

.tool-card-header-column > h1 {
  color: #eedd42;
  font-size: 16px;
  letter-spacing: 6px;
  text-align: center;
  font-family: "OpenSans-SemiBold";
}
.tool-card-header-column > p {
  color: #888888;
  font-size: 14px;
  letter-spacing: 2px;
  text-align: start;
  margin-top: 8px;
  font-family: "OpenSans-SemiBold";
}

.tool-card-header-column > p > span {
  color: #eedd42;
  font-size: 14px;
  letter-spacing: 2px;
  text-align: center;
  font-family: "OpenSans-SemiBold";
}

.tool-card-desc {
  color: #888888;
  font-size: 16px;
  font-family: "OpenSans-SemiBold";
  text-align: center;
  letter-spacing: 6px;
}
</style>
